module.exports = __webpack_public_path__ + "static/media/Drake - Do Not Disturb.ff0fe5b3.mp3";